import React from 'react';

export const VideoOnIcon = (props) => {
  const { className = '', style = {}, disabled = false, onClick } = props;
  return (
    <svg
      className={`custom-icon ${disabled ? 'disabled' : ''} ${className}`}
      onClick={disabled ? null : onClick}
      style={style}
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_36394_36177)">
        <path
          d="M27.4286 9.88415C26.6005 9.40634 25.6069 9.41926 24.7916 9.92289L21.8744 11.7179C21.4923 9.87124 19.8744 8.47656 17.9381 8.47656H8.76616C6.5496 8.48948 4.75342 10.3103 4.75342 12.5573V20.4088C4.75342 22.6557 6.5496 24.4766 8.76616 24.4766H17.9381C19.8744 24.4766 21.4923 23.0819 21.8617 21.2352L24.7789 23.0302C25.1993 23.2885 25.6706 23.4176 26.1292 23.4176C26.5623 23.4176 27.0082 23.3014 27.4158 23.069C28.2439 22.5912 28.7534 21.726 28.7534 20.7574V12.1957C28.7534 11.2272 28.2566 10.362 27.4158 9.88415H27.4286ZM19.6579 20.4088C19.6579 21.3773 18.8808 22.1521 17.9381 22.1521H8.76616C7.81074 22.1521 7.04641 21.3644 7.04641 20.4088V12.5573C7.04641 11.5887 7.82348 10.8139 8.76616 10.8139H17.9381C18.8935 10.8139 19.6579 11.6017 19.6579 12.5573V20.4088ZM26.4604 20.7703C26.4604 20.9253 26.3713 21.0157 26.2948 21.0544C26.2184 21.0932 26.1037 21.1319 25.9763 21.0544L23.0974 19.2724V13.6937L25.9763 11.9116C26.1037 11.8341 26.2311 11.8599 26.2948 11.9116C26.3713 11.9503 26.4604 12.0407 26.4604 12.1957V20.7833V20.7703Z"
          fill="#D9ECFA"
        />
      </g>
      <defs>
        <clipPath id="clip0_36394_36177">
          <rect width="32" height="32" fill="white" transform="translate(0.753418 0.476562)" />
        </clipPath>
      </defs>
    </svg>
  );
};
